/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 性能测试接口
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PerformencePhoneParams {
  constructor(public phone: string) {}
}

export default async function (
  params: PerformencePhoneParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.CuUser;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/performence-phone`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
